import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-is-checked"]
const _hoisted_2 = { class: "the-radio-button__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "the-radio-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick(_ctx.item[_ctx.trackById]))),
    "data-is-checked": _ctx.fullValue === _ctx.item[_ctx.trackById]
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "the-radio-button__circle" }, null, -1)),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item[_ctx.trackByName]), 1)
  ], 8, _hoisted_1))
}